import { useState, useEffect } from "react";
import { $host } from "../../../../http";

const ParagraphModal = ({ isOpen, onClose, paragraph, courseId, onSave }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const isEdit = Boolean(paragraph);

    useEffect(() => {
        if (paragraph) {
            setTitle(paragraph.title || "");
            setDescription(paragraph.description || "");
        } else {
            setTitle("");
            setDescription("");
        }
    }, [paragraph]);

    if (!isOpen) return null;

    const handleSave = async () => {
        try {
            const formData = new FormData();
            formData.append("title", title);
            formData.append("description", description);
            if (image) formData.append("image", image);

            let response;
            if (isEdit) {
                response = await $host.put(`/api/teachers/paragraphs/${paragraph.id}`, formData, { withCredentials: true });
            } else {
                response = await $host.post(`/api/teachers/paragraphs/create/${courseId}`, formData, { withCredentials: true });
            }

            onSave(response.data);
            onClose();
        } catch (error) {
            console.error("Ошибка сохранения параграфа:", error.response?.data?.message || error.message);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg w-96">
                <h2 className="text-xl font-bold mb-4">{isEdit ? "Редактировать параграф" : "Создать параграф"}</h2>
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="w-full border p-2 rounded mb-2" />
                <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="w-full border p-2 rounded mb-2" />
                <input type="file" onChange={(e) => setImage(e.target.files[0])} className="mb-2" />
                <div className="flex justify-between">
                    <button onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Отмена</button>
                    <button onClick={handleSave} className="bg-blue-500 text-white px-4 py-2 rounded">{isEdit ? "Сохранить" : "Создать"}</button>
                </div>
            </div>
        </div>
    );
};

export default ParagraphModal;
